/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {SignalAdminResourceApiBase} from '../common/controller/signal-admin-resource-api';
import {AdnApiClientService} from '../common/controller/adn-api-client.service';

export interface PaymentModel {
  id: string;
  createTime?: string;
  provider?: string;
  status?: string;
  statusTimestamp?: string;
  amount?: any;
  billedAmount?: any;
  refundedAmount?: any;
  receiptUrl?: string;
  appliedCoupon?: {id: string; name?: string};
  couponDiscountAmount?: any;
  lineItem?: {id: string; name?: string};
}

@Injectable({providedIn: 'root'})
export class PaymentApiService extends SignalAdminResourceApiBase<PaymentModel> {
  constructor(client: AdnApiClientService) {
    super(client, 'payment');
  }
}
